import React from 'react';
import { useParams } from 'react-router-dom';
import usePageClassName from '../hooks/usePageClassName';
const ExtraPage = ({ page }) => {
    const params = useParams();
    usePageClassName('generic-page');
    const Page = page;
    return React.createElement(Page, Object.assign({}, params));
};
export default ExtraPage;
//# sourceMappingURL=extra.js.map